import { z } from "zod";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

// Mirrors PublicCreditPacksController's response. Only `verifyBonus` /
// `signupBonus` are consumed today (dashboard completion nudge), but we model
// the whole pricing payload so the buy-credits UI can share this resource.
export const publicCreditPackSchema = z.object({
  packCode: z.string(),
  creditCount: z.number().int(),
  amountVnd: z.string(),
  unitPriceVnd: z.string(),
  originalPriceVnd: z.string().nullable(),
  note: z.string().nullable(),
});

export const publicPricingSchema = z.object({
  signupBonus: z.number().int(),
  verifyBonus: z.number().int(),
  currency: z.literal("VND"),
  packs: z.array(publicCreditPackSchema),
});

export type PublicPricing = z.infer<typeof publicPricingSchema>;

export function createPublicResource(ctx: RequestContext) {
  return {
    /** Signup/verify bonus + active credit packs. No auth — safe to cache. */
    pricing() {
      return requestJson(ctx, {
        method: "GET",
        path: `/public/credit-packs`,
        dataSchema: publicPricingSchema,
        auth: false,
      });
    },
  };
}
